import Typography from "@portal/components/atoms/v2/typography";
import { useEffect, useRef } from "react";
import Button from "@portal/components/atoms/v2/buttons/button";

import { IUserMessageProps } from "./types";
import { DialogComponent } from "@portal/components/organisms/DialogComponent";
import { SendMessageForResize } from "@portal/app/(iframe)/helpers/sendMessageForResize";

/**
 * Component for a message box showed to the user.
 * @param interface
 * @returns a box with a user message and variable options.
 */
export const UserMessageComponent = ({
  userMessage,
  content,
  showDialog,
  primaryButtonClick,
  secondaryButtonClick,
  primaryButtonText = "",
  secondaryButtonText = "",
  wide = false,
}: IUserMessageProps) => {
  const primaryButtonRef = useRef<HTMLButtonElement>(null);

  const secondaryButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (primaryButtonRef?.current) primaryButtonRef.current.focus();
    else if (secondaryButtonRef?.current) secondaryButtonRef.current.focus();
  }, [primaryButtonRef, secondaryButtonRef]);

  useEffect(() => {
    SendMessageForResize("sparerobot", "sparerobot");
  }, [showDialog]);

  return (
    <DialogComponent
      open={showDialog}
      onClose={() => null}
      panelClassName={`top-40 ${wide ? "w-full sm:w-160" : "w-80"} rounded-lg border border-greyBorder p-4`}
    >
      <div className="flex flex-col justify-center space-y-5">
        {userMessage && <Typography variant="Body">{userMessage}</Typography>}
        {content && content}
        <div className="flex justify-evenly">
          {secondaryButtonClick && <Button ref={secondaryButtonRef} onClick={secondaryButtonClick} text={secondaryButtonText} />}
          {primaryButtonClick && <Button ref={primaryButtonRef} onClick={primaryButtonClick} primary text={primaryButtonText} />}
        </div>
      </div>
    </DialogComponent>
  );
};
